import { configureStore, type Action, type ThunkAction } from "@reduxjs/toolkit";
import { formDrawerSlice } from "components/common/formDrawer/formdrawer.slice";

export const store = configureStore({
    reducer: {
        formDrawerState: formDrawerSlice.reducer,
    },
});


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

